import React from "react";

// Official MediGenie wordmark — loaded as a transparent PNG.
// Aspect ratio is ~2.8:1, so width auto-derives from height.
export function MediGenieLogo({ size = 32, dark = false }) {
  return (
    <div className="flex items-center" data-testid="medigenie-logo">
      <img
        src="/medigenie-logo.png"
        alt="MediGenie"
        style={{ height: size, width: "auto", display: "block" }}
        className={`select-none ${dark ? "" : ""}`}
        draggable={false}
      />
    </div>
  );
}
